import { useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import PrintIcon from "@mui/icons-material/Print";

import { settings } from "app";
import LoadingActionButton from "server/components/LoadingActionButton";
import { previewFileFromUrl } from "server/components/DownloadFile";

// Shared by the incoming internship students and the incoming regular students - the caller builds
// the api path, this only prefixes the gateway and opens the pdf.
const GenerateDocumentButton = ({ url, fileName, label, refreshAfter = false, margin }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);

    // previewFileFromUrl notifies on failure itself and opens the pdf in a new tab on success
    await previewFileFromUrl(`${settings.gatewayApi}/${url}`, fileName, notify);

    setLoading(false);

    // the letter of acceptance advances the status, which unlocks further documents
    if (refreshAfter) refresh();
  };

  return (
    <LoadingActionButton
      label={label}
      icon={<PrintIcon />}
      onClick={handleClick}
      loading={loading}
      disabled={loading}
      width="auto"
      minWidth={220}
      margin={margin}
    />
  );
};

export default GenerateDocumentButton;
